<template>

    <div>

        <Tabbed uriRoot="alerts" :names="names">
            <template #Alerts>
                <Alerts />
            </template>
            <template #EmailAddresses>
                <EmailAddresses />
            </template>
        </Tabbed>

    </div>

</template>

<script>
import Tabbed from './Tabbed.vue'
import Alerts from './Alerts/Alerts.vue'
import EmailAddresses from './Alerts/EmailAddresses.vue'
export default {
    name: 'AlertsHome',
    components: { Tabbed, Alerts, EmailAddresses },
    data() {
        return {
            names: { 
                Alerts:{ title: '', permalink: 'all', tab: 'Alerts' }, 
                EmailAddresses:{ title: '', permalink: 'email-addresses', tab: 'Email Addresses' }
            }
        }
    },
    methods: {
        
    }
}
</script>